import { reverse } from 'named-urls'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Dropdown, ToolbarButton, useMediaQueryContext } from '@fourthwall/components'
import { DotsHorizontalIcon } from '@fourthwall/icons'
import { routing } from '@utils/routing'

import type { App } from '../../types'

export type AppDropdownProps = {
  app: App
  onDelete: (app: App) => void
}

export const AppDropdown = ({ app, onDelete }: AppDropdownProps) => {
  const media = useMediaQueryContext()
  const navigate = useNavigate()

  const handleFullEditClick = () => {
    navigate(reverse(routing.settings.platformApps.editApp.self, { appId: app.id }))
  }

  return (
    <Dropdown
      content={
        <>
          <Dropdown.Item label="Edit" onClick={handleFullEditClick} />
          <Dropdown.Item label="Delete" onClick={() => onDelete(app)} />
        </>
      }
      position="bottom-start"
    >
      <ToolbarButton
        label="Settings"
        icon={DotsHorizontalIcon}
        color={media.tablet ? undefined : 'var(--icon-secondary)'}
      />
    </Dropdown>
  )
}
